<template lang="pug">
  .camps
    .camps__search-form
      button.button.button_full.hide-xs-up.search-form-button-toggle(
        @click="isShowFilter = toggleFilter()"
      )
        .button__text Фильтр
      search-form(
      v-show="isShowFilter"
      :without-title="true"
      )
    .camps__body
      .camps__map
        l-map(
          ref='mainMap'
          id='mainMap'
          :zoom='zoom'
          :center='center'
          :options='mapOptions'
        )
          l-tile-layer(
            :url='url'
          )
          l-marker-cluster(
            ref='cluster'
            :options='clusterOptions'
          )
            l-marker(
              v-for='(shift, $index) in shiftsMapData'
              v-if="shift.camp"
              :data-id="$index"
              :lat-lng='[shift.camp.geo_lat, shift.camp.geo_lon]'
              :key='$index'
              :icon="generateIcon()"
            )
              l-popup
                .obj.obj_tooltip
                  .obj__media(
                  v-if="shift.photos.length > 0"
                  )
                    img(
                      v-bind:src="shift.photos[0].preview_376x340"
                    )
                  router-link.obj__body(
                  :to="`/pages/shifts/${shift.id}/`"
                  )
                    .obj__name {{ shift.camp.name }}
                    .obj__title {{ shift.name }}
                    .obj__description Возраст: 6-18 лет
                    .obj__info-container
                      .obj__date {{ shift.date_started | monthDayDateString }} - {{ shift.date_finished | monthDayDateString }}
                        span.obj__days(v-if="shift.duration") {{ shift.duration }} дней
                      .obj__price(v-if="shift.price") {{ shift.price | price }} Р

      .camps__side.camps-side(
      ref="sideBlock"
      )
        .camps-side__header
          .camps-side__title
            | {{ caseSetting(shiftsCount, vocabulary.found) }} {{ shiftsCount }} {{ caseSetting(shiftsCount, vocabulary.shift) }}
          <!--.camps-side__filter-->
            <!--select.select-->
              <!--option По рейтингу-->
              <!--option По рейтингу-->
              <!--option По рейтингу-->
        .camps-side__body
          .obj-list.obj-list_vertical
            .obj-list__item(
              v-for="shift in shiftsData"
            )
              .obj.obj_horizontal
                .obj__media
                  image-slider(
                  :data-images="shift.slider_preview"
                  )
                router-link(:to="`/pages/shifts/${shift.id}/`").obj__body
                  .obj__name(
                    v-if="shift.camp"
                  ) {{ shift.camp.name }}
                  .obj__title {{ shift.name }}
                  .obj__description Возраст: {{shift.age_from}}-{{shift.age_to}} лет
                  .obj__info-container
                    .obj__date {{ shift.date_started | monthDayDateString }} - {{ shift.date_finished | monthDayDateString }}
                      span.obj__days(v-if="shift.duration") {{ shift.duration }} дней
                    .obj__price(v-if="shift.price") от {{ shift.price | price }} Р
    .camps__footer
      main-footer
</template>

<script>
import {mapActions, mapState} from "vuex";

import L from "leaflet";
import {LMap, LTileLayer, LMarker, LPopup} from "vue2-leaflet";

import LMarkerCluster from "vue2-leaflet-markercluster";

import ImageSlider from "@/components/imageSlider/ImageSlider.vue";
import searchForm from "@/components/searchForm/SearchForm.vue";
import Rating from "@/components/rating/Rating.vue";
import MainFooter from "@/components/footer/Footer.vue";

export default {
  name: "Shifts",
  components: {
    searchForm,
    ImageSlider,
    Rating,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LMarkerCluster,
    MainFooter
  },
  data() {
    return {
      isShowFilter: false,
      toggleFilterIsActive: false,
      windowWidth: window.innerWidth,
      clusterOptions: {
        // iconCreateFunction: cluster => {
        //   return this.createClusterIcon(cluster);
        // },
        showCoverageOnHover: false,
        animateAddingMarkers: false,
        maxClusterRadius: 100
      },
      zoom: 8,
      center: L.latLng(55.315919, 50.985943),
      url: "https://a.tile.openstreetmap.de/{z}/{x}/{y}.png",
      // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      mapOptions: {
        attributionControl: false
      },
      // shiftsData: [],
      vocabulary: {
        found: ["Найдена", "Найдено", "Найдено"],
        shift: ["смена", "смены", "смен"]
      },

      shiftsData: [],
      shiftsMapData: [],
      shiftsCount: null,
      scrollStatus: true,
      requestParams: null,
      shiftsPaginationQt: 30,
      shiftsOffset: 0
    };
  },
  methods: {
    ...mapActions(["getShifts", "getShiftsMap"]),
    generateIcon() {
      return L.icon({
        iconUrl: require("../../../../assets/images/map/marker.svg"),
        iconSize: [40, 40],
        iconAnchor: [20, 20]
      });
    },
    caseSetting(number, words) {
      number = +(number + "").slice(-2);
      for (var i = 11; i <= 14; i++) {
        if (number === i) {
          return words[2];
        }
      }
      number = +(number + "").slice(-1);
      for (var j = 2; j <= 4; j++) {
        if (number === j) return words[1];
      }
      if (number === 1) {
        return words[0];
      } else {
        return words[2];
      }
    },
    toggleFilter() {
      this.toggleFilterIsActive = !this.toggleFilterIsActive;
      return !this.isShowFilter;
    },
    setIsShowFilter(windowWidth) {
      if (windowWidth > 720) {
        this.isShowFilter = true;
      } else {
        if (!this.toggleFilterIsActive) {
          this.isShowFilter = false;
        }
      }
    },

    setRequestParams() {
      this.requestParams = this.$route.query;
      this.requestParams.limit = this.shiftsPaginationQt;
      this.requestParams.offset = this.shiftsOffset;
    },
    dataRequest(params, isAddition) {
      this.getShifts({params}).then((res) => {
        if (!isAddition) {
          this.shiftsData = [];
        }
        this.shiftsCount = res.count;
        if (res.results.length === 0) {
          this.scrollStatus = false;
          return;
        }
        const arr = res.results.map(shift => {
          shift.slider_preview = shift.photos
            .map(photo => photo.preview_376x340)
            .slice(0, 5);
          return shift;
        });
        this.shiftsData = this.shiftsData.concat(arr);
        this.scrollStatus = true;
        this.requestParams.offset += this.shiftsPaginationQt;
      });
    },
    buildShifts() {
      this.$root.$emit("on-show-preloader");
      this.dataRequest(this.requestParams, false);
      //загрузка данных для карты
      this.getShiftsMap({
        params: this.requestParams
      }).then((res) => {
        this.shiftsMapData = res;
        this.$root.$emit("on-hide-preloader");
      });
    }
  },
  mounted() {
    this.setRequestParams();
    this.buildShifts();

    this.setIsShowFilter(this.windowWidth);
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };

    this.$refs.sideBlock.addEventListener("scroll", (e) => {
      const clientHeight = this.$refs.sideBlock.clientHeight;
      const scrollHeight = this.$refs.sideBlock.scrollHeight;
      const scrollTop = this.$refs.sideBlock.scrollTop;
      const point = scrollHeight / this.requestParams.offset * 8;
      if (scrollTop > (scrollHeight - clientHeight - point) && this.scrollStatus) {
        this.scrollStatus = false;
        this.dataRequest(this.requestParams, true);
      }
    });
  },
  watch: {
    "$route.query"() {
      this.setRequestParams();
      this.buildShifts();
      this.$refs.sideBlock.scrollTop = 0;
    },
    windowWidth(val) {
      this.setIsShowFilter(val);
    }
  }
};
</script>
